exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header h1 {\n  margin-bottom: 0; }\n\nheader h2 {\n  margin-top: 0;\n  opacity: .5; }\n\n.profile-picture {\n  max-width: 25rem;\n  max-height: 25rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/user/user-view/user-view.component.scss
// module id = ../../../../../src/app/user/user-view/user-view.component.scss
// module chunks = main